var React = require('react');

function UserDropdownMenuLogOff (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#000000","d":"M12 10v-2h-5v-2h5v-2l3 3zM11 9v4h-5v3l-6-3v-13h11v5h-1v-4h-8l4 2v9h4v-3z"}));
}

UserDropdownMenuLogOff.displayName = "UserDropdownMenuLogOff";

UserDropdownMenuLogOff.defaultProps = {"version":"1.1","width":"100%","height":"100%","viewBox":"0 0 16 16"};

module.exports = UserDropdownMenuLogOff;

UserDropdownMenuLogOff.default = UserDropdownMenuLogOff;



//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-react-loader/lib/loader.js!./src/svg/menu-icons/user-dropdown-menu-log-off.svg
// module id = 1016
// module chunks = 0